import './style.scss';

const Pagination = (props) => {
  const {
    totalPages,
    currentPage,
    changeFunction,
    pagesToShow,
    disabled
  } = props;

  const firstPage = (currentPage === 1);
  const lastPage = (totalPages <= 1) || (currentPage === totalPages);

  const onChange = (targetPage) => {
    if (typeof changeFunction === 'function') {
      changeFunction(targetPage);
    }
  };


  const siblingCount = Math.max(pagesToShow - 1, 0);
  const leftCount = Math.floor(siblingCount / 2);
  const rightCount = Math.ceil(siblingCount / 2);
  const pages = [];
  for (let page = (currentPage - leftCount); page <= (currentPage + rightCount); page++) {
    if ((page >= 1) && (page <= totalPages)) {
      pages.push(page);
    }
  }
  // this bit handles cases where we don't have enough room on the sides for all the siblings
  while (pages.length < (pagesToShow)) {

    const nextPage = pages[pages.length - 1] + 1;
    const previousPage = pages[0] - 1;

    if (nextPage <= totalPages) {
      pages.push(nextPage);
    } else if (previousPage >= 1) {
      pages.unshift(previousPage);
    } else {
      break;
    }
  }

  return (
    <div className="pagination-container" data-testid='pagination'>
      <button
      className="page-button previous"
      aria-label="previous page"
      disabled={disabled || firstPage}
      onClick={(e) => {
        e.preventDefault();
        onChange(Math.max(1, currentPage - 1));
      }}
      >Previous</button>

    {
      pages.map((page, idx) => {
        if (page === currentPage) {
          return <span data-testid="page-button" key={idx} className="page-button current">{page}</span>
        }

        let pageString = `${page}`;
        // on last page that we are showing in the widget
        if (idx === (pages.length - 1)) {
          // not actual the last page of results
          if (page !== totalPages) {
            pageString += '...';
          }
        }


        return (
          <button
          key={idx}
          data-testid="page-button"
          className="page-button"
          disabled={disabled}
          aria-label={`page ${page}`}
          onClick={(e) => { e.preventDefault(); onChange(page); }}
          >{pageString}</button>
        );
      })
    }


      <button
      className="page-button next"
      aria-label="next page"
      disabled={disabled || lastPage}
      onClick={(e) => {
        e.preventDefault();
        onChange(Math.min(totalPages, currentPage + 1));
      }}
      >Next</button>
    </div>
  );

};

export default Pagination;
